import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';
import { WatchOptions } from 'vue';

@Component
export default class InputRadioButton extends InputBase<string> {
  @Prop() public option?: string;
  @Prop() public secondLabel?: string;
  private checked?: boolean = false;

  protected mounted() {
    this.inputType = 'radio';
    if (this.value !== undefined && this.value === this.option) {
      this.checked = true;
    }
  }

  /**
   * Override onValueChanged from InputBase
   */
  protected onValueChanged(value: string, oldValue: string) {
    if (oldValue !== value && value !== undefined && value === this.option) {
      this.checked = true;
    }
  }
}
